export const validationTC = () => {
  const TC = document.getElementById('TC');

  if (TC) {
    TC.addEventListener('change', (e) => {
      let display = 'block';
      if (e.currentTarget.checked) {
        display = 'none';
        document.querySelector('.cart-button-js').classList.remove('disable');
      } else {
        document.querySelector('.cart-button-js').classList.add('disable');
      }

      document.querySelector('.cart-error-js').style.display = display;
    });
  }
};
